import React, { useState } from "react";
import { Modal } from "@redriver/cinnamon";
import { Accordion, Grid, Icon } from "semantic-ui-react";

const ThreadModal = ({ data, ...props }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  return (
    <Modal.Information header="Thread info" size="large" {...props}>
      <div className="modalScrollContent">
        {data && (
          <Accordion fluid>
            {data.Threads.map((t, i) => (
              <React.Fragment key={"f" + i}>
                <Accordion.Title
                  key={"t" + i}
                  active={activeIndex == i && t.Stack.length != 0}
                  index={i}
                  onClick={() =>
                    t.Stack.length &&
                    setActiveIndex(i == activeIndex ? null : i)
                  }
                >
                  <Grid>
                    <Grid.Column width={3}>
                      <Icon name="dropdown" />
                      <b>ID</b>: {t.OsId} / {t.ManagedId}
                    </Grid.Column>
                    <Grid.Column width={3}>
                      {[
                        t.IsAlive ? "Alive" : null,
                        t.IsBackground ? "Background" : null,
                      ]
                        .filter((x) => x)
                        .join(", ")}
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <div className="stackPreview">
                        {t.Stack.length == 0 ? "(No stack)" : t.Stack[0]}
                      </div>
                    </Grid.Column>
                    <Grid.Column width={2}>
                      <b>CPU</b>: {Math.floor(t.CpuSecPerSec * 10000) / 100}%
                    </Grid.Column>
                  </Grid>
                </Accordion.Title>
                <Accordion.Content
                  active={activeIndex == i && t.Stack.length != 0}
                  key={"c" + i}
                >
                  <ol>
                    {t.Stack.map((f, j) => (
                      <li key={j}>{f}</li>
                    ))}
                  </ol>
                </Accordion.Content>
              </React.Fragment>
            ))}
          </Accordion>
        )}
      </div>
    </Modal.Information>
  );
};

export default ThreadModal;
